export const currency = '$';
export const currentYear = new Date().getFullYear();
export const developedByLink = 'https://coderthemes.com/';
export const developedBy = 'Coderthemes';
export const contactUs = 'coderthemes@gmail.com';
export const buyLink = '';
export const basePath = '';
export const DEFAULT_PAGE_TITLE = 'Abstack-NextJS | Responsive Bootstrap 5 Admin Dashboard';

// Replace the URL's value in env with your backend's URL or if you're using nextjs's API, add the server's origin URL
export const API_BASE_PATH = '';
export const colorVariants = ['primary', 'secondary', 'success', 'danger', 'warning', 'info', 'dark', 'purple', 'pink', 'orange', 'light', 'link'];